import React, { useContext, useEffect, useState } from 'react'
import { useGridApiRef } from '@mui/x-data-grid-pro'
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button'
import CreateClient from './CreateClient'
import { BankOutlined, CloseOutlined, EditOutlined, ExclamationCircleOutlined, FilterOutlined, UserAddOutlined } from '@ant-design/icons'
import ClientFilters from '../../components/filters/ClientFilters'
import GeneralContext from '../../context/GeneralContext/GeneralContext'
import { useNavigate, useParams } from "react-router-dom";
import styles from '../../services/styles';
import { Button, Popconfirm } from 'antd'
import column_grid_client_list from '../grid_columns/column_grid_client_list '
import { displayMessage } from '../../helpers/messages'
import { SL_Grid } from '../../components/grid/SL_Grid'

const { tc1, tc2, bc1, bc6 } = styles

export default function ListClients() {
    const navigate = useNavigate()


    const [clients, setClients] = useState([])
    const [currentClient, setCurrentClient] = useState(null)
    const [isModalCreateClientVisible, setIsModalCreateClientVisible] = useState(false)
    const [isFiltersVisible, setIsFiltersVisible] = useState(false)


    const gridRef = useGridApiRef()

    const {
        setShowLoading,
        windowWidth,
        windowHeight,
        mobile_mode,
    } = useContext(GeneralContext)

    const loadClientData = async (values) => {
        try {
            setShowLoading(true)
            await loadClients(values)
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    useEffect(() => {
        loadClientData({})
    }, [])

    async function loadClients(values) {
        let formattedValues = {}
        if (values?.by_cnpj && values.by_cnpj !== '') {
            formattedValues = { ...formattedValues, by_cnpj: values.by_cnpj }
        }
        if (values?.by_name && values.by_name !== '') {
            formattedValues = { ...formattedValues, by_name: values.by_name }
        }
        if (values?.by_active !== '' && values?.by_active !== undefined && values?.by_active !== null) {
            formattedValues = { ...formattedValues, by_active: values.by_active }
        }
        const { data } = await api.client.list(formattedValues)
        gridRef.current.setSelectionModel([])
        setClients(data)
    }

    const handleRowChange = (e) => {
        // console.log(e?.row)
        setCurrentClient(e?.row)
    }

    const handleOnCloseModalCreateClient = async (loadData) => {
        if (loadData) {
            await loadClients({})
        }

        setIsModalCreateClientVisible(false)
    }

    const handleOnOpenModalCreateClient = () => {
        setIsModalCreateClientVisible(true)
    }


    const handleOnGoToDetailClient = () => {
        navigate('' + currentClient.id)
    }

    const handleOnOpenFilters = () => {
        setIsFiltersVisible(true)
    }
    const handleOnCloseFilters = () => {
        setIsFiltersVisible(false)
    }

    const toggleActiveState = async (info) => {
        setShowLoading(true)
        try {
            if (!info?.id) {
                alert(displayMessage('ERROR_UPDATE_CLIENT_STATUS'), 'error', displayMessage('ERROR'))
                return
            }

            await api.client.changeActive(info.id)

            await loadClients()
        } finally {
            setShowLoading(false)
        }
    }

    const extraColumn = {
        field: 'is_active_toggle',
        headerName: 'Situação',
        sortable: false,
        align: 'center',
        renderCell: function (params) {
            return (
                <div style={{ padding: 2 }}>
                    <Popconfirm
                        placement="topRight"
                        title={displayMessage('CONFIRM_CHANGE_STATUS_USER')}
                        onConfirm={() => toggleActiveState(params?.row)}
                        icon={
                            <ExclamationCircleOutlined
                                style={{
                                    color: 'red'
                                }}
                            />
                        }>
                        <Button
                            style={{ minWidth: 80 }}
                            type={'primary'}
                            danger={params.row.active ? false : true}
                        >
                            {params.row.active ? displayMessage('IS_ACTIVE') : displayMessage('IS_INACTIVE')}
                        </Button>
                    </Popconfirm>
                </div>
            )
        }
    }


    return (
        <>
            {isModalCreateClientVisible && <CreateClient handleOnCloseModal={handleOnCloseModalCreateClient} handleOnSearchClients={loadClientData} />}

            <div className="flex flex-col flex-1 h-full">
                <div className={`flex w-full bg-fit-red-700 p-2 rounded-tl-[4px] rounded-tr-[4px] flex-wrap ${mobile_mode ? 'flex-col items-center gap-4' : 'gap-2'}`}>
                   
                    <div className='self-center text-white font-semibold text-base'>{displayMessage('CLIENTS_LIST')}</div>

                    <div className={`flex-1 flex flex-wrap gap-2 justify-end`}>
                        <SL_Button
                            type='default'
                            className={`flex items-center flex-1 ${mobile_mode ? 'w-[200px]' : 'max-w-[200px]'}`}
                            onClick={handleOnGoToDetailClient}
                            disabled={!currentClient || currentClient == null}
                            icon={<EditOutlined className='text-base flex items-center' />}
                        >
                            <span className='text-fit-red-800 font-semibold flex-1'>
                                {displayMessage('DETAIL_CLIENT')}
                            </span>
                        </SL_Button>

                        <SL_Button
                            type='default'
                            className={`flex items-center flex-1 ${mobile_mode ? 'w-[200px]' : 'max-w-[200px]'}`}
                            onClick={handleOnOpenModalCreateClient}
                            icon={<BankOutlined className='text-base flex items-center' />}
                        >
                            <span className='text-fit-red-800 font-semibold flex-1'>
                                {displayMessage('REGISTER_CLIENT')}
                            </span>
                        </SL_Button>

                        <Button
                            type='default'
                            shape="circle"
                            // className={`flex items-center flex-1 ${mobile_mode ? 'w-[50px]' : 'max-w-[50px]'}`}
                            onClick={isFiltersVisible ? handleOnCloseFilters : handleOnOpenFilters}
                            icon={!isFiltersVisible ? <FilterOutlined className='text-fit-red-800 flex items-center justify-center' /> : <CloseOutlined className='text-fit-red-800 flex items-center justify-center' />}
                        >
                        </Button>
                    </div>
                </div>
                {
                    isFiltersVisible ?
                        <ClientFilters handleOnSearchClients={loadClientData} filterHeight={'20vh'} />
                        :
                        <div />
                }
                <div className={`w-full flex-1 min-h-[400px] smb:min-h-0 mb-[20px]`}>
                    <SL_Grid
                        rows={clients ?? []}
                        apiRef={gridRef}
                        columns={column_grid_client_list.concat(extraColumn)}
                        onRowClick={handleRowChange}
                    />
                </div>
            </div>
        </>
    )
}
